import defaultApi from '@/utils/request';

export default {
  Load(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_UserAdmin/Load',
      params,
    });
  },
  Get(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_UserAdmin/Get',
      params,
    });
  },
  GetByEmpid(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_UserAdmin/GetByEmpid',
      params,
    });
  },
  Add(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_UserAdmin/Add',
      data,
    });
  },
  Update(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_UserAdmin/Update',
      data,
    });
  },
  Disable(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_UserAdmin/Disable',
      headers: { 'Content-Type': 'application/json' },
      data,
    });
  },
  ChangePermission(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_UserAdmin/ChangePermission',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data,
    });
  },
  AddOrUpdateStyle(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_UserAdmin/AddOrUpdateStyle',
      data,
    });
  },
};
